import { Component, OnInit } from '@angular/core';
import { ProfileportfolioService } from '@tech-services/profileportfolio.service';
import { Location } from '@angular/common';
import { CommonService } from '@tech-services/common.service';
import { environment } from '@tech-environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '@tech-utils/app-config.service';
import { takeUntil } from 'rxjs/operators';
import { CompletedataService } from '@tech-services/completedata.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'tech-openpdf',
  templateUrl: './openpdf.component.html',
  styleUrls: ['./openpdf.component.scss'],
})
export class OpenpdfComponent implements OnInit {
  private unsubscribe$ = new Subject();
  public showReturn: boolean = false;
  public text: string;

  constructor(
    private profilePortfolioService: ProfileportfolioService,
    private completedataService: CompletedataService,
    private commonService: CommonService,
    private translate: TranslateService,
    private location: Location
  ) {}

  ngOnInit() {
    this.commonService.showMenuSource.next(false);
    this.translate.get('k000263').subscribe((text: string) => {
      this.text = text;
    }); //Token: Esperando pdf
    this.translate.get('k000342').subscribe((text: string) => {
      this.text += '. ' + text;
    }); //Token: Este proceso llevará unos segundos.
    this.lauchPdf();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  private lauchPdf() {
    if (localStorage.getItem('OpenPdf')) {
      switch (localStorage.getItem('OpenPdf')) {
        case 'portfolioreport':
          this.commonService.isloading();
          if (
            localStorage.getItem('PortfolioCode') &&
            localStorage.getItem('InitialDate') &&
            localStorage.getItem('EndDate')
          ) {
            //Recogemos los localstorage necesarios
            let portfolioCode = localStorage.getItem('PortfolioCode');
            let initialDate = localStorage.getItem('InitialDate');
            let endDate = localStorage.getItem('EndDate');
            //Eliminamos todos los LocalStorage que hemos utilizaado para dejarlos limpios
            localStorage.removeItem('OpenPdf');
            localStorage.removeItem('PortfolioCode');
            localStorage.removeItem('InitialDate');
            localStorage.removeItem('EndDate');

            this.profilePortfolioService
              .GetPortfolioPdfUrlReport(portfolioCode, initialDate, endDate)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((data) => {
                this.translate.get('k001781').subscribe((text: string) => {
                  this.text = text;
                }); //Token: Pdf downloaded
                this.commonService.isnotloading();
                this.showReturn = true;

                const byteArray = new Uint8Array(
                  atob(data.PdfBase64)
                    .split('')
                    .map((char) => char.charCodeAt(0))
                );
                let file = new File([byteArray], data.PdfName, {
                  type: 'application/pdf',
                });
                let blobUrl = URL.createObjectURL(file);
                window.location.href = blobUrl;
              });
          } else {
            this.translate.get('k001782').subscribe((text: string) => {
              this.text = text;
            }); //Token: No hay datos para realizar su solicitud
            this.showReturn = true;
            //Eliminamos todos los LocalStorage que hemos utilizaado para dejarlos limpios
            localStorage.removeItem('OpenPdf');
            localStorage.removeItem('PortfolioCode');
            localStorage.removeItem('InitialDate');
            localStorage.removeItem('EndDate');
          }
          break;
        case 'custodian':
          this.commonService.isloading();
          if (localStorage.getItem('custodianDoc')) {
            //Recogemos los localstorage necesarios
            let custodianDoc = JSON.parse(localStorage.getItem('custodianDoc'));
            //Eliminamos todos los LocalStorage que hemos utilizaado para dejarlos limpios
            localStorage.removeItem('OpenPdf');
            localStorage.removeItem('custodianDoc');

            this.completedataService
              .getCustodioDoc(custodianDoc.Id)
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe((data) => {
                this.translate.get('k001781').subscribe((text: string) => {
                  this.text = text;
                }); //Token: Pdf downloaded
                this.commonService.isnotloading();
                this.showReturn = true;
                const byteArray = new Uint8Array(
                  atob(data)
                    .split('')
                    .map((char) => char.charCodeAt(0))
                );
                let file = new File(
                  [byteArray],
                  custodianDoc.DocumentCode + '-' + custodianDoc.Description,
                  {
                    type: 'application/pdf',
                  }
                );
                let blobUrl = URL.createObjectURL(file);
                window.location.href = blobUrl;
              });
          } else {
            this.translate.get('k001782').subscribe((text: string) => {
              this.text = text;
            }); //Token: No hay datos para realizar su solicitud
            this.showReturn = true;
            localStorage.removeItem('OpenPdf');
            localStorage.removeItem('custodianDoc');
          }
          break;
        case 'contract':
          this.commonService.isloading();
          //Eliminamos todos los LocalStorage que hemos utilizaado para dejarlos limpios
          localStorage.removeItem('OpenPdf');

          this.completedataService
            .getContractDoc(localStorage.getItem('portfolioCode'))
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data) => {
              this.translate.get('k001781').subscribe((text: string) => {
                this.text = text;
              }); //Token: Pdf downloaded
              this.commonService.isnotloading();
              this.showReturn = true;
              const byteArray = new Uint8Array(
                atob(data)
                  .split('')
                  .map((char) => char.charCodeAt(0))
              );
              let file = new File([byteArray], data.PdfName, {
                type: 'application/pdf',
              });
              let blobUrl = URL.createObjectURL(file);
              window.location.href = blobUrl;
            });
          break;
        case 'exonerationDoc':
          this.commonService.isloading();
          //Eliminamos todos los LocalStorage que hemos utilizaado para dejarlos limpios
          localStorage.removeItem('OpenPdf');

          this.completedataService
            .getExonerationDoc(localStorage.getItem('portfolioCode'))
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((data) => {
              this.translate.get('k001781').subscribe((text: string) => {
                this.text = text;
              }); //Token: Pdf downloaded
              this.commonService.isnotloading();
              this.showReturn = true;
              const byteArray = new Uint8Array(
                atob(data)
                  .split('')
                  .map((char) => char.charCodeAt(0))
              );
              let file = new File([byteArray], data.PdfName, {
                type: 'application/pdf',
              });
              let blobUrl = URL.createObjectURL(file);
              window.location.href = blobUrl;
            });
          break;
        default:
          break;
      }
    } else {
      this.translate.get('k001782').subscribe((text: string) => {
        this.text = text;
      }); //Token: No hay datos para realizar su solicitud
      this.showReturn = true;
      localStorage.removeItem('OpenPdf');
    }
  }

  public retun() {
    window.close();
  }
}
